module.exports = __webpack_public_path__ + "img/icon.ff76bdf0.svg";